export const DESKTOP_GRID_WIDTH = 1140;
export const CONTAINER_HORIZONTAL_MARGIN = 20;
// To be 560px on a container of 1140px
export const LEFT_CONTAINER_MD_WIDTH = '49.13%';
